// Duplicate of globals.css
export const themeDefaults = {
  fg: {
    '--color-foreground': {
      dark: 'oklch(83.58% 0.022 256.7)',
      light: 'oklch(14.05% 0.004 285.8)',
    },
    '--color-muted-foreground': {
      dark: 'oklch(71.48% 0.03 285.6)',
      light: 'oklch(60.19% 0.014 285.9)',
    },
    '--color-accent-foreground': {
      dark: 'oklch(100% 0 0)',
      light: 'oklch(0% 0 0)',
    },
    '--color-popover-foreground': {
      dark: 'oklch(83.58% 0.022 256.7)',
      light: 'oklch(14.05% 0.004 285.8)',
    },
    '--color-success-foreground': {
      dark: 'oklch(54.54% 0.147 146.41)',
      light: 'oklch(54.54% 0.147 146.41)',
    },
    '--color-warning-foreground': {
      dark: 'oklch(73.97% 0.1762 58.46)',
      light: 'oklch(73.97% 0.1762 58.46)',
    },
    '--color-destructive-foreground': {
      dark: 'oklch(58.74% 0.2 26.63)',
      light: 'oklch(58.74% 0.2 26.63)',
    },
    '--color-info-foreground': {
      dark: 'oklch(71.31% 0.153 253.37)',
      light: 'oklch(61.94% 0.166 250.69)',
    },
  },
  bg: {
    '--color-background': {
      dark: 'oklch(21.95% 0.008 285.7)',
      light: 'oklch(97.16% 0.007 286.28)',
    },
    '--color-muted': {
      dark: 'oklch(26.61% 0.0074 285.9)',
      light: 'oklch(93.84% 0.0041 286.3)',
    },
    '--color-accent': { dark: 'oklch(0% 0 0)', light: 'oklch(85.81% 0 0)' },
    '--color-popover': {
      dark: 'oklch(18.31% 0.004 286)',
      light: 'oklch(100% 0 0)',
    },
    '--color-success': {
      dark: 'oklch(27.4% 0.021 175.28)',
      light: 'oklch(96.02% 0.02 147.85)',
    },
    '--color-warning': {
      dark: 'oklch(26.51% 0.028 79.04)',
      light: 'oklch(96.92% 0.028 79.85)',
    },
    '--color-destructive': {
      dark: 'oklch(28% 0.055 10.69)',
      light: 'oklch(95.6% 0.023 7.19)',
    },
    '--color-info': {
      dark: 'oklch(26.2% 0.024 253.71)',
      light: 'oklch(95.27% 0.022 238.7)',
    },
    '--color-card': {
      dark: 'oklch(18.31% 0.004 286)',
      light: 'oklch(100% 0 0)',
    },
    '--color-card-nested': {
      dark: 'oklch(21.95% 0.0077 285.7)',
      light: 'oklch(98.81% 0 0)',
    },
  },
  utility: {
    '--color-border': {
      dark: 'oklch(31.11% 0.009 285.9)',
      light: 'oklch(90.42% 0.003 286.3)',
    },
    '--color-ring': {
      dark: 'oklch(75.05% 0.0044 285.8)',
      light: 'oklch(54.05% 0.004 285.8)',
    },
    '--color-primary': {
      dark: 'oklch(72.29% 0.1921 149.6)',
      light: 'oklch(56.32% 0.151 149.4)',
    },
    '--color-primary-foreground': {
      dark: 'oklch(26.64% 0.063 152.9)',
      light: 'oklch(98.48% 0 0)',
    },
    '--color-secondary': {
      dark: 'oklch(29.83% 0.005 286.1)',
      light: 'oklch(84.65% 0.003 286.3)',
    },
    '--color-secondary-foreground': {
      dark: 'oklch(83.58% 0.0219 256.7)',
      light: 'oklch(14.05% 0.004 285.8)',
    },
  },
}

export const themeVariables = [
  ...Object.keys(themeDefaults.fg),
  ...Object.keys(themeDefaults.bg),
  ...Object.keys(themeDefaults.utility),
]

export type ThemeVar = keyof typeof themeDefaults
